import React, { useState } from "react";
import { useCreateUser } from "../../../../api/addEmployee/employee";
import { notifyError } from "../../../../utils/ToastifyProvider";

const AddEmployee = () => {
  const [formData, setFormData] = useState({
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    department: "",
    position: "",
    gender: "",
    password: "",
    confirmPassword: "",
  });

  const { mutate, isLoading } = useCreateUser();

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      notifyError("Passwords do not match");
      return;
    }

    mutate(formData, {
      onSuccess: () => {
        setFormData({
          username: "",
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          department: "",
          position: "",
          gender: "",
          password: "",
          confirmPassword: "",
        });
      },
      onError: (err) => {
        notifyError(err.response?.data?.message || "An error occurred");
        // console.error("API Error:", err);
      },
    });
  };

  return (
    <div className="min-h-screen h-auto overflow-auto flex items-center justify-center px-4 py-10">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-3xl bg-gray-50 border border-gray-300 rounded-lg shadow p-8"
      >
        <h2 className="text-3xl font-bold text-center mb-6 text-black">
          Add Employee
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Username */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Username
            </label>
            <input
              type="text"
              placeholder="Enter Username"
              value={formData.username}
              onChange={(e) => handleChange("username", e.target.value)}
              required
              className="w-full border border-gray-300 rounded-md py-2 px-4"
            />
          </div>

          {/* First Name */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> First Name
            </label>
            <input
              type="text"
              placeholder="Enter First Name"
              value={formData.firstName}
              onChange={(e) => handleChange("firstName", e.target.value)}
              required
              className="w-full border border-gray-300 rounded-md py-2 px-4"
            />
          </div>

          {/* Last Name */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Last Name
            </label>
            <input
              type="text"
              placeholder="Enter Last Name"
              value={formData.lastName}
              onChange={(e) => handleChange("lastName", e.target.value)}
              required
              className="w-full border border-gray-300 rounded-md py-2 px-4"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Email
            </label>
            <input
              type="email"
              placeholder="Enter Email"
              value={formData.email}
              onChange={(e) => handleChange("email", e.target.value)}
              required
              className="w-full border border-gray-300 rounded-md py-2 px-4"
            />
          </div>

          {/* Mobile */}
          <div>
            <label className="block text-sm font-semibold mb-1">Mobile</label>
            <input
              type="tel"
              placeholder="Enter Mobile"
              value={formData.mobile}
              onChange={(e) => handleChange("mobile", e.target.value)}
              className="w-full border border-gray-300 rounded-md py-2 px-4"
            />
          </div>

          {/* Department */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Department
            </label>
            <select
              value={formData.department}
              onChange={(e) => handleChange("department", e.target.value)}
              required
              className="w-full border border-gray-300 rounded-md py-2 px-4 bg-white"
            >
              <option value="">Select Department</option>
              <option value="Administration">Administration</option>
              <option value="Information Technology">
                Information Technology
              </option>
              <option value="Accounting & Finance">Accounting & Finance</option>
              <option value="Design & Creative">Design & Creative</option>
              <option value="Human Resources">Human Resources</option>
              <option value="Digital Marketing">Digital Marketing</option>
              <option value="Warehouse & Logistics">
                Warehouse & Logistics
              </option>
              <option value="Customer Success">Customer Success</option>
              <option value="E-Commerce">E-Commerce</option>
            </select>
          </div>

          {/* Position */}
          <div>
            <label className="block text-sm font-semibold mb-1">Position</label>
            <input
              type="text"
              placeholder="Enter Position"
              value={formData.position}
              onChange={(e) => handleChange("position", e.target.value)}
              className="w-full border border-gray-300 rounded-md py-2 px-4"
            />
          </div>

          {/* Gender */}
          <div>
            <label className="block text-sm font-semibold mb-1">Gender</label>
            <select
              value={formData.gender}
              onChange={(e) => handleChange("gender", e.target.value)}
              className="w-full border border-gray-300 rounded-md py-2 px-4 bg-white"
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {/* Password */}
          {/* <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Password
            </label>
            <input
              type="password"
              placeholder="Enter Password"
              value={formData.password}
              onChange={(e) => handleChange("password", e.target.value)}
              required
              className="w-full border border-gray-300 rounded-md py-2 px-4"
            />
          </div> */}

          {/* Confirm Password */}
          {/* <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Confirm Password
            </label>
            <input
              type="password"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={(e) => handleChange("confirmPassword", e.target.value)}
              required
              className="w-full border border-gray-300 rounded-md py-2 px-4"
            />
          </div> */}
        </div>

        {/* Submit Button */}
        <div className="flex justify-end gap-4 mt-8">
          <button
            type="submit"
            className={`bg-primary text-white rounded-full px-6 py-2 font-medium hover:opacity-90 transition ${
              isLoading ? "opacity-60 cursor-not-allowed" : ""
            }`}
            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddEmployee;
